import { __decorate } from "tslib";
import { AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { LogotypeInfo } from "./logotype_info";
export class OtherLogotypeInfo {
    constructor(params = {}) {
        this.logotypeType = "";
        this.info = new LogotypeInfo();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.ObjectIdentifier })
], OtherLogotypeInfo.prototype, "logotypeType", void 0);
__decorate([
    AsnProp({ type: LogotypeInfo })
], OtherLogotypeInfo.prototype, "info", void 0);
